import Modal from '@/components/shared/modal';
import { useState, Dispatch, SetStateAction, useCallback, useMemo } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { Copy } from 'lucide-react';
import {
  FacebookShareButton,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  TwitterShareButton,
  PinterestShareButton,
  VKShareButton,
  OKShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  RedditShareButton,
  EmailShareButton,
  TumblrShareButton,
  LivejournalShareButton,
  MailruShareButton,
  ViberShareButton,
  WorkplaceShareButton,
  LineShareButton,
  WeiboShareButton,
  PocketShareButton,
  InstapaperShareButton,
  HatenaShareButton,
  FacebookIcon,
  TwitterIcon,
  PinterestIcon,
  VKIcon,
  OKIcon,
  TelegramIcon,
  WhatsappIcon,
  RedditIcon,
  TumblrIcon,
  MailruIcon,
  EmailIcon,
  LivejournalIcon,
  ViberIcon,
  WorkplaceIcon,
  LineIcon,
  PocketIcon,
  InstapaperIcon,
  WeiboIcon,
  HatenaIcon
} from 'react-share';

type SignInModalProps = {
  showSignInModal: boolean;
  setShowSignInModal: Dispatch<SetStateAction<boolean>>;
  translations: any;
};

const SignInModal = ({ showSignInModal, setShowSignInModal, translations }: SignInModalProps) => {
  const [copySuccess, setCopySuccess] = useState(false);
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const _id = searchParams.get('_id');
  const currentUrl = process.env.NEXT_PUBLIC_BASE_URL + pathname; //"?_id=" + _id
  let shareUrl = currentUrl;
  let imageUrl = currentUrl;
  let title = 'Made With Create.Porn';

  return (
    <Modal showModal={showSignInModal} setShowModal={setShowSignInModal}>
      <div className="w-full overflow-hidden border-0 border-[#3C3C3C] shadow-xl sm:border-[0.5px] md:max-w-md md:rounded-2xl">
        <div className="flex flex-wrap items-center justify-center border-b border-b-[0.5px] border-[#3C3C3C] bg-[#202124] px-6 py-6 pt-8 text-center md:px-16">
          <FacebookShareButton url={shareUrl} quote={'AI Art'}>
            <FacebookIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </FacebookShareButton>
          <FacebookMessengerShareButton url={shareUrl} appId="521270401588372">
            <FacebookMessengerIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </FacebookMessengerShareButton>
          <TwitterShareButton url={shareUrl} title={title} className="p-2">
            <TwitterIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </TwitterShareButton>
          <TelegramShareButton url={shareUrl} title={title} className="p-2">
            <TelegramIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </TelegramShareButton>
          <WhatsappShareButton url={shareUrl} title={title} separator=":: ">
            <WhatsappIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </WhatsappShareButton>
          <PinterestShareButton url={shareUrl} media={imageUrl} className="p-2">
            <PinterestIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </PinterestShareButton>
          <VKShareButton url={shareUrl} image={imageUrl} className="p-2">
            <VKIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </VKShareButton>
          <OKShareButton url={shareUrl} image={imageUrl} className="p-2">
            <OKIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </OKShareButton>
          <RedditShareButton url={shareUrl} title={title} windowWidth={660} windowHeight={460}>
            <RedditIcon size={32} className="m-1 rounded-md" />
          </RedditShareButton>
          <TumblrShareButton url={shareUrl} title={title} className="p-2">
            <TumblrIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </TumblrShareButton>
          <LivejournalShareButton url={shareUrl} title={title} description={shareUrl}>
            <LivejournalIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </LivejournalShareButton>
          <MailruShareButton url={shareUrl} title={title} className="p-2">
            <MailruIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </MailruShareButton>
          <EmailShareButton url={shareUrl} subject={title} body="body">
            <EmailIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </EmailShareButton>
          <ViberShareButton url={shareUrl} title={title} className="p-2">
            <ViberIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </ViberShareButton>
          <WorkplaceShareButton url={shareUrl} quote={title} className="p-2">
            <WorkplaceIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </WorkplaceShareButton>
          <LineShareButton url={shareUrl} title={title} className="p-2">
            <LineIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </LineShareButton>
          <WeiboShareButton url={shareUrl} title={title} image={imageUrl}>
            <WeiboIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </WeiboShareButton>
          <PocketShareButton url={shareUrl} title={title}>
            <PocketIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </PocketShareButton>
          <InstapaperShareButton url={shareUrl} title={title}>
            <InstapaperIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </InstapaperShareButton>
          <HatenaShareButton url={shareUrl} title={title} windowWidth={660} windowHeight={460}>
            <HatenaIcon size={32} className="m-1 rounded-md hover:brightness-105" />
          </HatenaShareButton>
        </div>
        <div className="flex flex-col space-y-4 bg-[#313338] px-4 py-8 md:px-16">
          <div className="flex h-10 w-full items-center justify-center space-x-3 rounded-md border border border-gray-200 bg-white px-2 text-sm text-black shadow-sm transition-all duration-75 hover:bg-gray-50 focus:outline-none focus:ring-0">
            <div className="truncate text-[#2B2D31]">{currentUrl}</div>
            <button
              className={`m-2 flex flex-row items-center justify-center rounded-full bg-[#DD0772] px-1 py-1.5 backdrop-blur-xl hover:brightness-105`}
              onClick={() => {
                setShowSignInModal(true);
                setCopySuccess(true);
                navigator.clipboard.writeText(currentUrl);
              }}
            >
              <Copy color="white" className="my-auto ml-2 h-3 w-auto" />
              <div className="mx-2 overflow-ellipsis whitespace-nowrap text-xs text-white">
                {copySuccess ? translations.copied : translations.copy}
              </div>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export function useShareModal(translations: any) {
  const [showShareModal, setShowShareModal] = useState(false);

  const ShareModalCallback = useCallback(() => {
    return (
      <SignInModal
        showSignInModal={showShareModal}
        setShowSignInModal={setShowShareModal}
        translations={translations}
      />
    );
  }, [showShareModal, setShowShareModal]);

  return useMemo(
    () => ({ setShowShareModal, ShareModal: ShareModalCallback }),
    [setShowShareModal, ShareModalCallback]
  );
}
